export default __webpack_public_path__ + "static/media/1505fd59e41abc7a.79b345e93f4f820f2c194e2116070c6b.svg";